var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../Icon';
import './Modal.styles.scss';
import { Title } from '../Title';
import { Button } from '../Button';
var Modal = function (_a) {
    var _b, _c;
    var _d = _a.title, title = _d === void 0 ? '' : _d, onClose = _a.onClose, _e = _a.modalSize, modalSize = _e === void 0 ? 'md' : _e, children = _a.children, buttons = _a.buttons;
    var handleClose = function () {
        !!onClose && onClose();
    };
    return (_jsx("div", __assign({ className: "hefesto-modal__overlay" }, { children: _jsxs("div", __assign({ className: "hefesto-modal__container hefesto-modal__container--".concat(modalSize), "data-testid": "modal-container" }, { children: [_jsxs("div", __assign({ className: "hefesto-modal__header" }, { children: [_jsx(Title, __assign({ level: 3 }, { children: title })), !!onClose && (_jsx(Button, { name: "close-btn", type: "button", variant: "tertiary", onClick: handleClose, icon: _jsx(Icon, { option: "X" }) }))] })), _jsx("div", __assign({ className: "hefesto-modal__body" }, { children: children })), _jsxs("div", __assign({ className: "hefesto-modal__footer" }, { children: [!!buttons.left && (_jsx(Button, __assign({}, buttons.left, { variant: (_b = buttons.left.variant) !== null && _b !== void 0 ? _b : 'secondary', fullWidth: true }, { children: buttons.left.children }))), _jsx(Button, __assign({}, buttons.right, { variant: (_c = buttons.right.variant) !== null && _c !== void 0 ? _c : 'primary', fullWidth: true }, { children: buttons.right.children }))] }))] })) })));
};
export default Modal;
